var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16L6.99994 11L8.39994 9.55L10.9999 12.15V4H12.9999V12.15L15.5999 9.55L16.9999 11L11.9999 16ZM5.99994 20C5.44994 20 4.97911 19.8042 4.58744 19.4125C4.19577 19.0208 3.99994 18.55 3.99994 18V15H5.99994V18H17.9999V15H19.9999V18C19.9999 18.55 19.8041 19.0208 19.4124 19.4125C19.0208 19.8042 18.5499 20 17.9999 20H5.99994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.fd42574bb8158f4c43a428ad9fa9014f.svg";
export { ForwardRef as ReactComponent };